module.exports = __webpack_public_path__ + "media/images/ltw_logo-97858da18e3ddd0c4a723039d3e9e818.png";